import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { createRoot } from 'react-dom/client';
import 'react-medium-image-zoom/dist/styles.css';
import { BrowserRouter } from 'react-router';
import 'swiper/css';
import '../src/assets/css/all.css';
import reportWebVitals from './reportWebVitals';
import AppRoutes from './route';
import './styles/main.module.scss';
import { sendToVercelAnalytics } from './vitals';

const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AppRoutes />
    <Analytics mode="auto" />
    <SpeedInsights />
  </BrowserRouter>
);
console.log({ REACT_APP_EMAIL_SERVICE_ID: process.env.REACT_APP_EMAIL_SERVICE_ID });
reportWebVitals(sendToVercelAnalytics);
